import React from 'react';
import { IonGrid, IonRow, IonCol, IonText, IonBadge } from '@ionic/react';
import PropTypes from 'prop-types';
import Icon from 'src/components/Icon';
import Subscribe from 'src/components/Subscribe';
import DocumentsModal from 'src/components/DocumentsModal';
import ChatModal from 'src/components/ChatModal';
import DetailsModal from 'src/components/DetailsModal';
import MapModal from 'src/components/MapModal';
import './style.scss';

class JobBar extends React.Component {
  state = {
    openModal: null
  };

  openModal = (modalName) => this.setState({ openModal: modalName });

  closeModal = () => this.setState({ openModal: null });

  render() {
    const { openModal } = this.state;
    const { job, unseenComments } = this.props;
    const mapDisabled = !job.stages.find((stage) => stage.type === 'travel');
    return (
      <div id="JobBar">
        <IonGrid>
          <IonRow className="ion-text-center">
            <IonCol
              className="col-btn"
              onClick={() => this.openModal('details')}
            >
              <div className="mb-2">
                <Icon type="info-circle" />
              </div>
              <div>Details</div>
            </IonCol>
            <IonCol className="col-btn" onClick={() => this.openModal('docs')}>
              <div className="mb-2">
                <Icon type="image" />
              </div>
              <div>Docs</div>
            </IonCol>
            <IonCol className="col-btn" onClick={() => this.openModal('chat')}>
              <div className="mb-2">
                <IonText>
                  <Icon
                    type={
                      unseenComments.length ? 'comment-medical' : 'comments'
                    }
                  />
                </IonText>
              </div>
              <div>
                Chat{' '}
                {unseenComments.length > 0 && (
                  <IonBadge
                    className={
                      unseenComments.length
                        ? 'animated infinite flash slower'
                        : ''
                    }
                  >
                    {unseenComments.length}
                  </IonBadge>
                )}
              </div>
            </IonCol>
            <IonCol
              className={`col-btn ${mapDisabled ? 'disabled' : ''}`}
              onClick={() => {
                if (!mapDisabled) {
                  this.openModal('map');
                }
              }}
            >
              <div className="mb-2">
                <Icon type="map" />
              </div>
              <div>Map</div>
            </IonCol>
          </IonRow>
        </IonGrid>

        <DocumentsModal
          isOpen={openModal === 'docs'}
          onClose={this.closeModal}
          jobId={job._id}
        />
        <ChatModal
          isOpen={openModal === 'chat'}
          onClose={this.closeModal}
          jobId={job._id}
        />
        <DetailsModal
          isOpen={openModal === 'details'}
          onClose={this.closeModal}
          job={job}
        />
        <MapModal
          isOpen={openModal === 'map'}
          onClose={this.closeModal}
          job={job}
        />
      </div>
    );
  }
}

JobBar.propTypes = {
  job: PropTypes.object.isRequired,
  unseenComments: PropTypes.array.isRequired
};

export default (props) => {
  return (
    <Subscribe
      render={({ state }) => {
        return (
          <JobBar
            unseenComments={state.unseenComments.filter(
              (comment) => comment.job_id === props.job._id
            )}
            {...props}
          />
        );
      }}
    />
  );
};
